var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('entity-select',{attrs:{"entities-config":{
      entities: _vm.conditions,
      entitiesIcons: _vm.ConditionIcons
    },"button-title":_vm.$t('create_condition_button_create_title'),"popup-title":_vm.$t('create_condition_create_popup_title'),"disabled":_vm.disabled},on:{"select":_vm.selectCondition}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }